import api from "./api";

async function getMyMerchant({ includeContractDetails = false } = {}) {
  try {
    const response = await api.get(`api/merchants/mine`, {
      params: { includeContractDetails },
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

async function updateMerchantPaymentSettings({
  paymentRequests,
  checkout,
  corporateCardSurchargePercent,
  klarnaAccountEmail,
  passOnCorporateCardFee,
  checkoutPassOnCorporateCardFee,
  terminals,
}) {
  try {
    const response = await api.put(`api/merchants/mine/paymentsettings`, {
      paymentRequests,
      checkout,
      corporateCardSurchargePercent,
      klarnaAccountEmail,
      passOnCorporateCardFee,
      checkoutPassOnCorporateCardFee,
      terminals,
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

async function getNotificationChannels() {
  try {
    const response = await api.get(`api/merchants/mine/notificationChannels`);
    return response.data;
  } catch (error) {
    return [];
  }
}

async function createNotificationChannel(name, email, branchId, subscriptions) {
  try {
    const response = await api.post(`api/merchants/mine/notificationChannels`, {
      name,
      email,
      branchId,
      subscriptions,
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

async function updateNotificationChannel (id, { name, email, branchId }) {
  try {
    const response = await api.put(`api/merchants/mine/notificationChannels/${id}`, {
      name,
      email,
      branchId,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

async function deleteNotificationChannel(id) {
  try {
    const response = await api.delete(`api/merchants/mine/notificationChannels/${id}`);
    return response;
  } catch (error) {
    return null;
  }
}

async function getCustomerMetadata() {
  try {
    const response = await api.get(`api/merchants/mine/customermetadata`);
    return response.data;
  } catch (error) {
    return null;
  }
}

export {
  getMyMerchant,
  updateMerchantPaymentSettings,
  getNotificationChannels,
  createNotificationChannel,
  updateNotificationChannel ,
  deleteNotificationChannel,
  getCustomerMetadata,
};
